import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType } from '@eb/i18n';

import { IconButton } from '@eb/eds-icon-button';
import {
    STYLE_PROP_TYPE as ICON_BUTTON_STYLE_PROPTYPE,
    ICON_PROP_TYPE as ICON_BUTTON_ICON_PROPTYPE,
} from '@eb/eds-icon-button';

const EventCardAction = ({
    iconType,
    style,
    title,
    secondary,
    onClick,
    isListCard,
}) => {
    let component = null;
    const iconClassName = classNames(
        'eds-event-card-content__actions-container__action',
        {
            'eds-l-pad-all-1': !isListCard,
            'eds-l-mar-right-2': !!secondary && !isListCard,
            'eds-event-card-content__actions-icon--primary': !secondary,
            'eds-event-card-content__actions-icon--secondary': !!secondary,
        },
    );

    if (iconType) {
        component = (
            <span className={iconClassName}>
                <IconButton
                    title={title}
                    style={style}
                    iconType={iconType}
                    onClick={onClick}
                />
            </span>
        );
    }

    return component;
};

export default class EventCardActions extends PureComponent {
    static propTypes = {
        primaryIconType: ICON_BUTTON_ICON_PROPTYPE,
        primaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
        primaryIconTitle: translationPropType,
        primaryIconOnClick: PropTypes.func,
        secondaryIconType: ICON_BUTTON_ICON_PROPTYPE,
        secondaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
        secondaryIconTitle: translationPropType,
        secondaryIconOnClick: PropTypes.func,
        shouldShowIcons: PropTypes.bool,
        isListCard: PropTypes.bool,
    };

    render() {
        const {
            primaryIconType,
            primaryIconStyle,
            primaryIconTitle,
            primaryIconOnClick,
            secondaryIconType,
            secondaryIconStyle,
            secondaryIconTitle,
            secondaryIconOnClick,
            isListCard,
            shouldShowIcons,
        } = this.props;
        const classes = classNames(
            'eds-event-card-content__actions-container eds-event-card-content__actions-container--consumer',
            {
                'eds-event-card-content__actions-container--always-visible': shouldShowIcons,
            },
        );

        return (
            <div className={classes}>
                <EventCardAction
                    iconType={secondaryIconType}
                    style={secondaryIconStyle}
                    title={secondaryIconTitle}
                    onClick={secondaryIconOnClick}
                    secondary={secondaryIconType}
                    isListCard={isListCard}
                />

                <EventCardAction
                    iconType={primaryIconType}
                    style={primaryIconStyle}
                    title={primaryIconTitle}
                    onClick={primaryIconOnClick}
                    isListCard={isListCard}
                />
            </div>
        );
    }
}
